import {ThemeProps} from "atmosfair-ui"

export const theme: ThemeProps = {
    colors: {
        primaryLighter: "#1789cd",
        primaryLight: "#147ab6",
        primary: "#0f5b88",
        primaryDark: "#0a3c5a",
        primaryDarker: "#072d43",

        secondaryLighter: "#b9d576",
        secondaryLight: "#afcf62",
        secondary: "#9bc23c",
        secondaryDark: "#7c9b30",
        secondaryDarker: "#6c882a",

        highlight: "#0f5b88",
        hover: "#147ab6",
        focus: "#1789cd",
        active: "#0f5b88",

        fondGreen: "#f6f8f2",
        rustRed: "#832120",

        black: "#4d4d4d",
        white: "#FFFFFF",

        warningLight: "#FFA500",
        warningMain: "#832120",
        warningDark: "#691b1a",

        infoLight: "#03A9F4",
        infoMain: "#0288D1",
        infoDark: "#01579B",

        successLight: "#4CAF50",
        successMain: "#2E7D32",
        successDark: "#1B5E20",

        textDisabled: "rgba(0, 0, 0, 0.12)",

        defaultIconColorInButton: "#FFFFFF",
        defaultIconColorOnlyIcon: "#0f5b88",
        othersDisabled: "#EBE8E8",
        iconDisabled: "#c2c0c0",

        lightGreyLighter: "#f5f5f5",
        lightGrey: "#E6E5E5",
        lightGreyDarker: "#C4C1BF",
        darkGrey: "#9D9D9E",
        darkGreyDarker: "#8A8A8A",
    },

    font: {
        fontFamily: "'Source Sans Pro', sans-serif",
        fontWeight: {
            lighter: 300,
            light: 300,
            regular: 400,
            bold: 700,
            bolder: 1000,
        },
        fontStyle: {
            italic: "italic",
            normal: "normal",
        },
        fontSize: {
            large: "36px",
            medium: "21px",
            regular: "16px",
            small: "12px",
            verySmall: "8px",
        },
    },

    spacer: {
        verySmall: 2,
        small: 5,
        medium: 10,
        large: 15,
        veryLarge: 20,
    },

    shadows: {
        softToBottom: "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
        mediumToBottom: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        strongToBottom: "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
        veryStrongToBottom: "0px 5px 5px -2px rgba(0, 0, 0, 0.2), 0px 5px 6px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",

        softToTop: "0px -2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
        mediumToTop: "0px -3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        strongToTop: "0px -3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
        veryStrongToTop: "0px -5px 5px -2px rgba(0, 0, 0, 0.2), 0px 5px 6px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",

        softToMiddle: "0px 0px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
        mediumToMiddle: "0px 0px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        strongToMiddle: "0px 0px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
        veryStrongToMiddle: "0px 0px 5px -2px rgba(0, 0, 0, 0.2), 0px 5px 6px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",

        softToRight: "2px 0px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
        mediumToRight: "3px 0px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        strongToRight: "3px 0px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
        veryStrongToRight: "5px 0px 5px -2px rgba(0, 0, 0, 0.2), 0px 5px 6px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)",
    },

    button: {
        verySmall: {height: "14px", width: "14px"},
        small: {height: "18px", width: "18px"},
        mediumSmall: {height: "20px", width: "20px"},
        medium: {height: "22px", width: "22px"},
        large: {height: "26px", width: "26px"},
        veryLarge: {height: "30px", width: "30px"},
    },

    iconButton: {
        verySmall: {height: "20px", width: "20px"},
        small: {height: "25px", width: "25px"},
        mediumSmall: {height: "27px", width: "27px"},
        medium: {height: "30px", width: "30px"},
        large: {height: "35px", width: "35px"},
        veryLarge: {height: "35px", width: "35px"},
    },

    borderRadius: {
        verySmall: "4px",
        small: "5px",
        medium: "7px",
        large: "9px",
    },

    misc: {
        activeScale: 0.95,
    },
} as const satisfies ThemeProps;
